
  import { defineComponent, ref } from 'vue'
  
  export default defineComponent({
    props: {
      visible: {
        type: Boolean,
        default: true,
      },
      title: {
        type: String,
        default: 'Form',
      },
      data: {
        type: Object,
      },
    },
    setup (props) {
      const formRef = ref()
      const form = ref(props.data)
      const fields = [
        {
          title: 'Date and Time',
          dataIndex: 'datetime',
          key: 'datetime',
        },
        {
          title: 'Action',
          dataIndex: 'action_name',
          key: 'action_name',
        },
        {
          title: 'Check Status',
          dataIndex: 'check_status',
          key: 'check_status',
        }
      ];
  
      return {
        form,
        formRef,
        fields,
      }
    },
  })
  